import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { Group } from '../definition';
import { GetVideoPosts } from '../stores/groups.actions';
import { GroupsState } from '../stores/groups.state';

@Component({
    selector: "app-dashboard-call-in",
    template: `
        <div class="px-normal mt-3">
            <h2 class="text-primary-500 font-bold">{{ title }}</h2>
        </div>
        <ng-container *ngIf="posts$ | async as posts">
            <ion-slides [options]="sliderOptions" class="pl-normal pt-normal mb-3">
                <ion-slide *ngFor="let post of posts.data | slice: 0:5">
                    <img *ngIf="post.image_thumb" class="mb-1 cursor-pointer" [routerLink]="['/groups/', post.group.id, 'posts', post.id]" [src]="post.image_thumb" />
                </ion-slide>
            </ion-slides>
        </ng-container>
        <ng-template #empty>
            <app-view-empty [lead]="'Wir konnten leider keine passenden CALL-INs finden' | translate" [icon]="['fal', 'video']"> </app-view-empty>
        </ng-template>
        <div class="px-normal flex justify-center mt-3" *ngIf="showMore">
            <ion-button [routerLink]="['/informations']" [queryParams]="{ view: 'callin' }" fill="outline" shape="round">
                {{ "Mehr CALL-INs anzeigen" | translate }}
            </ion-button>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardCallInComponent implements OnInit {
    @Select(GroupsState.videoPosts) posts$: Observable<Group>;
    @Input() showMore = true;
    @Input() diseaseId = null;
    @Input() title = marker("Aktuelle CALL-INs");

    sliderOptions: any = {
        spaceBetween: 12,
        slidesPerView: 1.3,
    };

    constructor(private store: Store) {}

    ngOnInit(): void {
        let params: any = { type: "video" };
        if (this.diseaseId) {
            params.disease_id = this.diseaseId;
        }
        this.store.dispatch([new GetVideoPosts()]).subscribe();
    }
}
